<script setup lang="ts">
definePageMeta({
  title: 'pages.myBookingLogin.seo.title',
  description: 'pages.myBookingLogin.seo.description',
});
</script>

<template>
  <div class="flex flex-col justify-center bg-gray-50 px-4 py-8 md:px-6 lg:min-h-screen-without-header lg:px-8">
    <UiCustomContainer>
      <MyBookingLogin />
    </UiCustomContainer>
  </div>
</template>
